import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { ButtonIcon } from "@waytek/MobiusOverrides/Button/Button";
import { removeBtnFocusBorder } from "@waytek/Utilities/styleguide/btnIcon";
import { fontFamily } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalGuardianBlue: getColor("common.global.guardianBlue"),
    globalWhite: getColor("common.global.white"),
};

export const pagination: {
    defaultProps?: PaginationPresentationProps;
} = {
    defaultProps: {
        buttonProps: {
            mergeCss: false,
            shape: "rectangle",
            size: 48,
            typographyProps: {
                mergeCss: false,
                size: 18,
                lineHeight: 1.5,
                weight: "normal",
                fontFamily,
            },

            css: css`
                ${removeBtnFocusBorder}

                border: 0;
                margin: 0;
                padding: 0 10px;
                background-color: #f2f2f2;
                color: ${localColors.globalGuardianBlue};

                &::after,
                &::before {
                    content: none;
                    display: none;
                }

                &:not(:disabled):hover {
                    background-color: ${localColors.globalGuardianBlue};
                    color: ${localColors.globalWhite};
                }

                &[data-test-selector="pagination_firstButton"],
                &[data-test-selector="pagination_previousButton"],
                &[data-test-selector="pagination_nextButton"],
                &[data-test-selector="pagination_lastButton"] {
                    background-color: ${localColors.globalWhite};
                    width: auto;
                }

                ${TypographyStyle} {
                    font-size: 18px;
                    font-weight: normal;
                    line-height: 1.5;
                }

                ${ButtonIcon} {
                    width: 20px;
                    height: 20px;
                    color: ${localColors.globalGuardianBlue};

                    svg {
                        width: 20px;
                        height: 20px;
                    }
                }
            `,
        },
        cssOverrides: {
            currentButton: css`
                background-color: ${localColors.globalGuardianBlue};
                color: ${localColors.globalWhite};

                &:not(:disabled):hover {
                    background-color: ${localColors.globalGuardianBlue};
                    color: ${localColors.globalWhite};
                }
            `,
            ellipsis: css`
                display: inline-block;
                height: 48px;
                padding: 0 10px;
                font-size: 18px;
                line-height: 48px;
                background-color: #f2f2f2;
                cursor: default;
            `,
            linkList: css`
                ul {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
            `,
        },
    },
};
